import React, { useState, useEffect, useContext } from "react";
import { Menu, X } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../assests/css/students/Mynavbar.css";
import logo from "../../../assests/Images/logo.jpg";
import { AppContext } from "../../../context/Appcontext";

const Mynavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { authToken } = useContext(AppContext);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

const navItems = [
  { title: "Home", path: "/" },
  { title: "Blogs", path: "/blogs" },
  { title: "About Us", path: "/aboutus" },
  { title: "Contact", path: "/contact" },
  { title: "Event", path: "/eventpage" },
  { title: "Principal", path: "/principal" },
  // { title: "Career", path: "/career" },
];

  // FIX: agar student already login hai (token mojood hai) to seedha dashboard
  const handleStudentClick = () => {
    const storedToken = authToken || localStorage.getItem("authToken");
    if (storedToken) {
      navigate("/student/dashboard");
    } else {
      navigate("/student-login");
    }
  };

  return (
    <nav className="ggc-navbar">
      <div className="navbar-container">
        <div className="navbar-content">

          {/* LOGO */}
          <Link to="/" className="brand-section">
            <img src={logo} alt="GGC Logo" className="logo-image" />
            <div className="brand-text">
              <h1 className="brand-title">GGC Gujranwala</h1>
              <p className="brand-tagline">Since 1954</p>
            </div>
          </Link>

          {/* DESKTOP NAV */}
          <div className="desktop-nav">
            {navItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={index}
                  to={item.path}
                  className={`nav-button ${isActive ? "active-link" : ""}`}
                >
                  <span className="nav-text">{item.title}</span>
                  {isActive && <span className="active-dot" />}
                </Link>
              );
            })}
          </div>

          {/* RIGHT BUTTONS */}
          <div className="right-icons">
            <button
              className="ggc-pill-btn ggc-pill-student"
              onClick={handleStudentClick}
            >
              Student
            </button>

            <button
              className="ggc-pill-btn ggc-pill-teacher"
              onClick={() => navigate("/teacher-login")}
            >
              Teacher
            </button>
          </div>

          {/* MOBILE ICON */}
          <button
            className="mobile-menu-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>

        {/* MOBILE MENU */}
        {isMenuOpen && (
          <div className="mobile-menu">
            {navItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                className="mobile-nav-button"
              >
                {item.title}
              </Link>
            ))}

            <div className="mobile-auth">
              <button
                className="ggc-pill-btn ggc-pill-student"
                onClick={handleStudentClick}
              >
                Student
              </button>

              <button
                className="ggc-pill-btn ggc-pill-teacher"
                onClick={() => navigate("/teacher-login")}
              >
                Teacher
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Mynavbar;